export function sanitizeFileName(fileName: string | undefined): string {
  return (
    fileName
      ?.substring(0, 230)
      .toLowerCase()
      .replace(/[^a-z0-9]/g, '_')
      .replace(/\s/g, '_')
      .replace(/[/\\?%*:|"<>]/g, '')
      .replace(/^_+|_+$/g, '')
      .trim() || 'Download'
  )
}
